var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-main',[_c('v-container',[_vm._v(" "+_vm._s(_vm.longName)+" "),_c('v-btn',{attrs:{"color":"info","block":""},on:{"click":_vm.logout}},[_vm._v(" LOGOUT ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }